export default __webpack_public_path__ + "static/media/cancel.a8a28bfe.svg";